function fn_comp_catalog_detail() {
    var $fn = $(".comp_catalog_detail"),
        $timeout;

    $.fn.elm_close = function() {
        var $this = $(this);
        $this.find(".part_ui_tooltip.mod--active").addClass("mod--closed");
        $timeout = setTimeout(function(){
            $this.find(".part_ui_tooltip.mod--active").removeClass("mod--active mod--closed");
        },300);
    };

    $fn.find("[data-open-tooltip]").on("click", function(e){
        var $this = $(this);
        e.preventDefault();
        e.stopPropagation();
        clearTimeout($timeout);
        $this.closest(".elm_options").find(".part_ui_tooltip").removeClass("mod--active");
        $this.next(".part_ui_tooltip").addClass("mod--active");

        $("html").on("click", function (e) {
            if ($(e.target).closest(".part_ui_tooltip").length === 0) {
                $fn.elm_close();
            }
        });
    });

    $fn.find(".part_ui_tooltip .icon--close").on("click", function(e){
       e.preventDefault();
       $fn.elm_close();
    });

    $fn.find(".part_ui_tooltip .elm_item input").on("change", function() {
        var $image = $(this).parent().data('src');
        $(this).closest('.part_ui_tooltip').find('.elm_image img').attr('src', $image);

    });
}